import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Giulia R.',
  location: 'Roma, IT'
}, {
  name: 'Francesca M.',
  location: 'Milano, IT'
}, {
  name: 'Chiara T.',
  location: 'Firenze, IT'
}, {
  name: 'Martina K.',
  location: 'Napoli, IT'
}, {
  name: 'Sara B.',
  location: 'Bologna, IT'
}, {
  name: 'Elena S.',
  location: 'Torino, IT'
}, {
  name: 'Valentina L.',
  location: 'Venezia, IT'
}, {
  name: 'Silvia C.',
  location: 'Palermo, IT'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-4 left-4 sm:top-4 sm:bottom-auto sm:left-auto sm:right-4 z-50 animate-slide-in" data-id="element-194">
          <div className="bg-white border-4 border-brand-accent shadow-2xl rounded-lg p-3 pr-8 max-w-[280px] relative overflow-hidden" data-id="element-195">
            <button onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-gray-400 hover:text-brand-dark transition-colors" data-id="element-196">
              <XIcon className="w-4 h-4" data-id="element-197" />
            </button>
            <div className="flex items-center gap-3" data-id="element-198">
              <div className="w-12 h-12 rounded-full bg-brand-accent/10 flex items-center justify-center shrink-0 border-2 border-brand-accent/30" data-id="element-199">
                <ShoppingBag className="w-6 h-6 text-brand-accent" data-id="element-200" />
              </div>
              <div className="leading-tight" data-id="element-201">
                <p className="font-black text-brand-dark text-sm" data-id="element-202">
                  {currentPurchase.name}
                </p>
                <p className="text-[11px] text-gray-500 font-bold uppercase tracking-wider" data-id="element-203">
                  {currentPurchase.location}
                </p>
                <p className="text-xs text-brand-green font-bold mt-1" data-id="element-204">
                  ha appena acquistato YOGA PRO™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}